/* eslint-disable max-len */
import { createFeature, createReducer, on } from '@ngrx/store';
import * as luxon from 'luxon';

import * as actions from './inf-location-history.actions';
import { InfLocationHistoryI } from 'src/app/api/inf-location-history/inf-location-history.result.int';

export interface State {
    error: string;
    loaded: boolean;
    loading: boolean;
    data: InfLocationHistoryI;
    receivedTime: string;
}

export const initialState: State = {
    error: null,
    loaded: false,
    loading: false,
    data: null,
    receivedTime: null,
};

export default createFeature({
  name: 'infLocationHistory',
  reducer: createReducer(
    initialState,
    on(actions.error, (state: State, { messageText }): State => ({
        ...state,
        error: messageText,
        loaded: false,
        loading: false
    })),
    on(actions.reset, (state: State): State => ({
        ...state,
        data: null,
        error: null,
        loaded: false,
        loading: false
    })),
    on(actions.received, (state: State, { result }): State => ({
        ...state,
        data: result,
        error: null,
        loaded: true,
        loading: false,
        receivedTime: luxon.DateTime.now().toISO(),
    })),
    on(actions.load, (state: State, { }): State => ({
        ...state,
        data: null,
        loaded: false,
        loading: true
    }))
  )}
);